export default __webpack_public_path__ + "assets/7a181d313249ab8669ee4d8697e50af3.png";